import BaseComponent from '../../../js/base-component'
import { Splide } from '@splidejs/splide/build/complete/complete';

class AppointmentSlider extends BaseComponent {
  constructor(options) {
    super(options);
  }
  onInit() {
    this.splide = new Splide(this.element.querySelector('.u-appointment-slider__slider'), {
        pagination: false,
        perPage: 3,
        perMove: 1,
        breakpoints: {
            767: {
                arrows: false,
                pagination: true,
			          perPage: 1,
                perMove: 1,
		    },
            1023: {
                arrows: false,
                pagination: true,
                perPage: 2,
                perMove: 1,
                gap: "1rem",
            }
        },
        gap: "1rem",
    } );

    this.splide.mount();
  }
}

export default {
  name: 'AppointmentSlider',
  definition: AppointmentSlider
};